import { ErrorSidePanel } from '@/components/errors';
import { useGetAccountServices, useGetPersonalInfo } from '@/hooks/api';
import { createFileRoute } from '@tanstack/react-router';
import { type DefaultHouseHoldProps } from './-model/props';
import { useState } from 'react';
import { templates, type SkinPageConfig } from '@nosinovacao/nosid-mfe-common';
import { DefaultHouseHoldLight } from './-skins';
import { useSetDefaultAccount } from './-hooks/default-account.hook';

export const Route = createFileRoute('/(services)/services/_sheet/default-household/')({
  component: RouteComponent,
  errorComponent: ErrorSidePanel,
});

function RouteComponent() {
  const { data, isLoading } = useGetAccountServices();
  const { data: personalInfo } = useGetPersonalInfo();
  const services = (data?.Holder.ServiceAccounts ?? []).filter(
    (service, index, self) => self.findIndex((s) => s.Id === service.Id) === index,
  );
  const [selectedServiceAccount, setSelectedServiceAccount] = useState<string | null>(
    personalInfo?.DefaultAccountId ?? null,
  );
  const { mutateAsync: setDefaultAccount, isPending } = useSetDefaultAccount();
  function selectServiceAccount(id: string) {
    setSelectedServiceAccount(id);
  }
  async function submit() {
    if (!selectedServiceAccount) return;
    await setDefaultAccount(selectedServiceAccount);
    // get close button from data-slot="sheet-close". click it to close the sheet after submit. We do this to preserve close animations without extra context or prop drilling
    const closeButton = document.querySelector('[data-slot="sheet-close"]') as HTMLButtonElement;
    closeButton?.click();
  }
  const props: DefaultHouseHoldProps = {
    loading: isLoading,
    services: services,
    selectedServiceAccount,
    updateHouseHoldLoading: isPending,
    submit: () => void submit(),
    selectServiceAccount,
  };
  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: DefaultHouseHoldProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <DefaultHouseHoldLight {...props} />,
  };
}
